import styled from 'styled-components'
import { breakpoints } from '../../MediasQueries'

export const PageContainer = styled.div`
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
`

export const SectionSpacing = styled.div`
  margin-top: 24px;
`

export const FormSection = styled.div`
  padding: 24px 20px 20px;

  @media (max-width: ${breakpoints.md}) {
    padding: 18px 14px 16px;
  }
`

export const NewProduct = styled.form`
  width: 100%;
`

export const FlexInputs = styled.div`
  display: grid;
  grid-template-columns: 140px minmax(220px, 1.5fr) 170px 180px 1fr 1fr;
  gap: 14px;
  align-items: end;

  @media (max-width: 1280px) {
    grid-template-columns: repeat(3, minmax(220px, 1fr));
  }

  @media (max-width: ${breakpoints.md}) {
    grid-template-columns: 1fr;
    gap: 12px;
  }
`

export const FormActions = styled.div`
  margin-top: 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;

  @media (max-width: ${breakpoints.md}) {
    justify-content: flex-start;
  }
`